import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PageHeader, Alert } from 'react-bootstrap';

import BasicInfoSummary from './BasicInfoSummary';
import EducationInfoSummary from './EducationInfoSummary';
import OtherInfoSummary from './OtherInfoSummary';
import ProfessionalSummary from './ProfessionalSummary';
import PointsSummary from './PointsSummary';
import Confirmation from './Confirmation';

import '../styles/FormSummary.css';
import { PROGRAM_ADN } from "../config/constants";
import PTRequirementsSummary from "./PTRequirementsSummary";

class FormSummary extends Component {
  render() {
    const { basicInfo, educationInfo, professionalInfo, otherInfo, ptRequirementsInfo, application, programId } = this.props;
    return programId === PROGRAM_ADN ? (
      <div>
        <PageHeader>Application Summary</PageHeader>
        <Confirmation confirmations={application.confirmations} dispatch={this.props.dispatch} />
        <BasicInfoSummary {...basicInfo} />
        <EducationInfoSummary {...educationInfo} programId={programId}/>
        <ProfessionalSummary {...professionalInfo} colleges={educationInfo.colleges} />
        <OtherInfoSummary {...otherInfo} />
        <PointsSummary/>
        { application.upgradeOption &&
          <Alert bsStyle="info">Advanced Placement Requested</Alert>
        }
      </div>
    ) : (
      <div>
        <PageHeader>Application Summary</PageHeader>
        <Confirmation confirmations={application.confirmations} dispatch={this.props.dispatch} />
        <BasicInfoSummary {...basicInfo} />
        <EducationInfoSummary {...educationInfo} programId={programId} />
        <PTRequirementsSummary {...ptRequirementsInfo} />
      </div>
    );
  };
}

export default connect(
  (state) => {
    const { basicInfo, educationInfo, professionalInfo, otherInfo, ptRequirementsInfo, application, appInfo } = state;
    const { programId } = appInfo.application;
    return {
      basicInfo,
      educationInfo,
      professionalInfo,
      otherInfo,
      ptRequirementsInfo,
      application,
      programId
    };
  }
)(FormSummary);